import introJs from "intro.js";

export const useTour = () => {
  // @ts-ignore exclude-next-line
  const tour = introJs();

  const steps = [
    {
      title: "Welcome to the Tools! 🎉",
      intro:
        "Welcome to the Tools tour! 👋 We're excited to guide you through the main features of the project! Let's get started 🚀",
    },
    {
      title: "Header",
      element: ".app-header",
      intro:
        "In this section, you'll find the page title 📄, a short overview of your profile 👤, and a user menu button 🔽 for quick access to your settings and profile options.",
      position: "bottom",
    },
    {
      title: "User Profile Menu",
      element: ".tour-user-menu",
      intro:
        "This is your user menu 🔧. Here, you can change your theme 🌙/🌞, access your profile 👤, and switch to the old UI version where you can continue working from the same page you were on here 🔄.",
      position: "left",
    },
    {
      title: "Navigation Bar",
      element: ".tour-nav-bar",
      intro:
        "Here you can see all the available routes for your application 🌍. Use this navigation bar to move between pages 🚀.",
      position: "bottom",
    },
    {
      title: "Main Content",
      element: ".tour-content",
      intro:
        "Here you'll find all the content of the page 📄. This is where the core information and features are displayed 🔍.",
      position: "bottom",
    },
    {
      title: "Thank you for taking the tour! 🎉",
      intro:
        "You’ve reached the end of the tour! Now you’re ready to fully explore the features of our project, Tools. Enjoy using it and feel free to explore! 🚀",
    },
  ];

  tour.setOptions({
    tooltipClass: "customTooltip",
    exitOnEsc: false,
    showSkipButton: true,
    skipLabel: "Skip",
    overlayOpacity: 0.7,
    showButtons: true,
    showStepNumbers: false,
    exitOnOverlayClick: false,
    dontShowAgain: true,
    steps,
  });

  const startTour = () => {
    return tour.setOption("dontShowAgain", true).start();
  };

  return {
    tour,
    startTour,
  };
};
